





















































































































































































































































































































































































































































































































































































































































// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import Vue from 'vue';
import { COUNTRIES } from '../utils/constants';
import { LSS } from '../core/services';
import { CampaignsService } from '@services/campaigns.service';
import { CustomerTypes, Genders } from '../utils/enums';
import {
  IAudience,
  ICampaign,
  IAdGroup,
  ICampaignReq,
} from '@shared/interfaces';
import XLSX from 'xlsx';

import AddCreativeSet from '../components/campaign/AddCreativeSet.vue';

import { LS_DRAFT_KEY } from '@shared/config';
import {
  GET_CAMPAIGN_DRAFT,
  GET_CAMPAIGN_GROUPS,
  APPS_BY_ORG,
  COUNTRIES_FOR_APP,
} from '../utils/apollo-queries';
import {
  CAMPAIGN_DRAFT,
  CREATE_CAMPAIGN,
  CREATE_SEARCH_TAB_CAMPAIGN,
} from '../utils/apollo-mutations';
import { CampaignCreationSteps } from '../utils/enums';
import { IMutationOptions } from '../utils/interfaces';
import AddKeys from '../components/keywords/AddKeys.vue';
import AddnKeys from '../components/keywords/AddnKeys.vue';
import { forEach } from 'lodash';

export default Vue.extend({
  components: {
    AddCreativeSet,
    AddKeys,
    AddnKeys,
  },
  data() {
    return {
      addedCreativeSetDetails: null,
      expandAdScheduling: false,
      savingCampaign: false,
      csCountries: [],
      menuDisplays: null,
      ex4: null,
      successDialog: false,
      phones: [
        {
          size: '6.5” Display',
          description: 'Display iPhone XS Max',
        },
        {
          size: '6.1” Display',
          description: 'Display iPhone XR',
        },
        {
          size: '5.8” Display',
          description: 'Display iPhone X, iPhone XS',
        },
      ],
      ipads: [
        {
          size: '12.9” Display',
          description: 'Display iPad Pro 12.9”',
        },
        {
          size: '9.7” Display',
          description:
            'Display iPad Pro 9.7”, iPad (2017), iPad Air 2, iPad Air, iPad (4th generation)',
        },
      ],
      nKeysheaders: [
        {
          text: '',
          align: 'start',
          value: 'delete',
        },
        {
          text: 'Keyword',
          sortable: true,
          value: 'text',
        },
        { text: 'matchType', value: 'matchType' },
      ],
      tKeysheaders: [
        {
          text: '',
          align: 'start',
          value: 'delete',
        },
        {
          text: 'Keyword',
          sortable: true,
          value: 'text',
        },
        { text: 'MatchType', value: 'matchType' },
        { text: 'Amount', value: 'bidAmount.amount' },
        { text: 'Currrency', value: 'bidAmount.currency' },
      ],
      orgId: '',
      currency: '',
      loading: false,
      searchedApps: [],
      search: null,
      searchLoc: null,
      selectedApp: null,
      campaginGroups: [],
      drawer: true,
      mini: true,
      step: CampaignCreationSteps.APP_SELECTION,

      switch1: true,
      switch2: false,

      devices: ['Foo', 'Bar', 'Fizz', 'Buzz'],

      dialog: false,

      e2: 'Texas',
      e3: null,
      e4: null,
      states: [
        { text: 'State 1' },
        { text: 'State 2' },
        { text: 'State 3' },
        { text: 'State 4' },
        { text: 'State 5' },
        { text: 'State 6' },
        { text: 'State 7' },
      ],
      nullDatetime: null,
      datePickerProps: {
        min: new Date().toISOString(),
      },
      timePickerProps: {
        min: `${new Date().getHours()}:${new Date().getMinutes()}`,
      },
      datetime: new Date(),
      datetimeString: '2019-01-01 12:00',
      formattedDatetime: '09/01/2019 12:00',
      textFieldProps: {
        appendIcon: 'event',
      },
      dateProps: {
        headerColor: 'red',
      },
      timeProps: {
        useSeconds: true,
        ampmInTitle: true,
      },
      endTimeCheck: false,
      //start
      valid: true,

      //campaign
      campaignGroupName: '',
      appId: null,
      appDetailsForCreativeSet: null,

      //Countries Regions
      campaignName: null,
      selectedCountries: null,
      appCountries: [],
      Countries: null,
      budget: null,
      dailyCap: '',

      //adgroup
      adGroupName: '',
      selectDevices: '',
      Devices: ['IPAD', 'IPHONE'],
      startdate: null,
      enddate: '',
      menu1: false,
      startmodal: false,
      endmodal: false,
      menu2: false,
      defaultBidAmount: '',
      cpaGoal: '',
      daypart: null,
      checkbox: true,
      menu: null,
      date: null,

      //Keywords
      tKeys: [],
      nKeys: [],

      //search match
      autoOpt: false,

      ageRange: false,
      ageRangeValue: [18, 35],
      locations: [],

      selectedGender: Genders.ALL,
      selectedCustomerType: CustomerTypes.ALL,
      selectedLocation: '',

      //creative sets
      creativeappassets: null,
      creativeSetName: [],
      csName: '',
      tab: null,
      allImgs: {},
      selectedImgs: [],
      defaultImages: [],
      defaultGenIds: [],

      //Validation
      valid1: false,
      campaignGroupRules: [(v) => !!v || 'Please select campaign group!'],
      appRules: [(v) => !!v || 'Please select an app!'],

      valid2: false,
      countryRules: [(v) => !!(v && v.length) || 'Please select country!'],
      campaignNameRules: [(v) => !!v || 'Campaign name required!'],
      budgetRules: [
        (v) => !!v || 'Budget amount is required!',
        (v) => !!/^[0.1-9]*$/gi.test(v) || 'Please enter a valid budget!',
      ],

      valid3: false,
      adgroupNameRules: [(v) => !!v || 'Adgroup name required!'],
      cptBidRules: [
        (v) => !!v || 'Default Max CPT Bid is required!',
        (v) => !!/^[0.1-9]*$/gi.test(v) || 'Please enter a valid CPT Bid!',
      ],
      dailyCapRules: [
        (v) =>
          !!/^[0.1-9|(^$)]*$/gi.test(v) || 'Please enter a valid daily cap!',
      ],
      cpaGoalRules: [
        (v) =>
          !!/^[0.1-9|(^$)]*$/gi.test(v) || 'Please enter a valid CPA goal!',
      ],
      deviceRules: [(v) => !!(v && v.length) || 'Please select devices!'],
    };
  },
  computed: {
    c: function (): string {
      return '';
    },
    draftId: {
      cache: false,
      get(): string {
        return localStorage.getItem(LS_DRAFT_KEY) as string;
      },
      set(value: string): void {
        localStorage.setItem(LS_DRAFT_KEY, value);
      },
    },
        //audience
    customerTypes: {
      cache: false,
      get() {
        return [
        { text: this.$t('createCampaign.allUsers'), value: CustomerTypes.ALL },
        { text: this.$t('createCampaign.newUsers'), value: CustomerTypes.NEW },
        { text: this.$t('createCampaign.appUsers'), value: CustomerTypes.OTHER_APPS },
        { text: this.$t('createCampaign.existingUsers'), value: CustomerTypes.EXISITING },
      ];
      },
    },

    gender: {
      cache: false,
      get() {
        return [
        { text: this.$t('createCampaign.all'), value: Genders.ALL },
        { text: this.$t('createCampaign.male'), value: Genders.MALE },
        { text: this.$t('createCampaign.female'), value: Genders.FEMALE },
      ];
      },
    },
  },
  apollo: {
    apps: {
      query: APPS_BY_ORG,
      variables() {
        return {
          orgId: this.orgId,
        };
      },
      skip() {
        return !this.orgId;
      },
    },
    campaignDraft: {
      query: GET_CAMPAIGN_DRAFT,
      variables() {
        return {
          draftId: this.draftId,
        };
      },
      skip: true,
      update(data) {
        const campaignDraft: ICampaignReq = data.campaignDraft;
        LSS.campaign = campaignDraft.campaign;
        LSS.adGroup = campaignDraft.adGroup;
        LSS.orgId = campaignDraft.campaign.orgId;
        LSS.adamId = campaignDraft.campaign.adamId;
        this.step = campaignDraft.step + 1;
      },
    },
    getCampaignGroups: {
      query: GET_CAMPAIGN_GROUPS,
      skip(): boolean {
        return false;
      },
    },
    countriesForApp: {
      query: COUNTRIES_FOR_APP,
      variables() {
        return {
          adamId: this.selectedApp.adamId,
        };
      },
      skip() {
        return !this.selectedApp;
      },
      update(data) {
        this.setCountries(data.countriesForApp);
      },
    },
  },
  methods: {
    closeSuccessDialog() {
      this.successDialog = false;
      LSS.clearOther();
      this.$router.push('/ads-manager');
    },
    async createCampaign() {
      this.savingCampaign = true;
      const campaignRequest: ICampaignReq = {
        campaign: LSS.campaign,
        adGroup: LSS.adGroup,
      };
      try {
        const result = await this.runMutation({
          mutationQuery: CREATE_SEARCH_TAB_CAMPAIGN,
          variables: { orgId: LSS.orgId, campaignRequest },
        });

        this.savingCampaign = false;
        if (result.data.createSearchTabCampaign.searchAdsErrors) {
          return this.$notify.error(result.data.createSearchTabCampaign.searchAdsErrors);
        }
        this.successDialog = true;
      } catch (error) {
        this.savingCampaign = false;
        console.log(error);
      }
    },
    async saveAsDraft() {
      const campaignDraft: ICampaignReq = {
        campaign: LSS.campaign,
        adGroup: LSS.adGroup,
        step: this.step,
      };

      await this.runMutation({
        mutationQuery: CAMPAIGN_DRAFT,
        variables: { campaignDraft },
      });
    },
    async searchLocations(locationName: string, countrycode: string) {
      this.loading = true;
      this.locations = await CampaignsService.searchedLocations(
        this.orgId,
        locationName,
        countrycode
      );
      this.loading = false;
    },
    setProperties() {
      LSS.orgId = this.orgId;
      LSS.adamId = this.selectedApp.adamId;

      this.step = CampaignCreationSteps.COUNTRIES_REGIONS;
    },
    async saveCountriesRegions() {
      const campaign: ICampaign = {
        countriesOrRegions: this.selectedCountries,
        name: this.campaignName,
        budgetAmount: {
          currency: this.currency,
          amount: this.budget,
        },
        ...(this.dailyCap && {
          dailyBudgetAmount: {
            currency: this.currency,
            amount: this.dailyCap,
          },
        }),
        orgId: parseInt(LSS.orgId),
        adChannelType: 'DISPLAY',
        supplySources: ['APPSTORE_SEARCH_TAB'],
        adamId: parseInt(LSS.adamId),

        billingEvent: 'IMPRESSIONS',
      };

      LSS.campaign = campaign;
      this.step = CampaignCreationSteps.AD_GROUP;
    },

    async saveAdGroupObject() {
      LSS.campaign = {
        ...LSS.campaign,
        startTime: this.startdate,
        ...(this.enddate && {
          endTime: this.enddate,
        }),
      };

      const adGroup: IAdGroup = {
        orgId: parseInt(LSS.orgId),
        status: 'ENABLED',
        name: this.adGroupName,
        pricingModel: 'CPM',
        defaultBidAmount: {
          currency: this.currency,
          amount: this.defaultBidAmount,
        },
        ...(this.cpaGoal && {
          cpaGoal: {
            currency: this.currency,
            amount: this.cpaGoal,
          },
        }),
        startTime: this.startdate,
        ...(this.enddate && { endTime: this.enddate }),
        targetingDimensions: {
          deviceClass: {
            included: this.selectDevices,
          },
          country: {
            included: LSS.campaign.countriesOrRegions,
          },
          ...(this.daypart && {
            daypart: {
              userTime: {
                included: this.daypart.split(','),
              },
            },
          }),
        },
        automatedKeywordsOptIn: false,
      };
      LSS.adGroup = adGroup;
      this.step = CampaignCreationSteps.SEARCH_MATCH;
    },

    async appendAudience() {
      const adamId = LSS.adamId;
      const allOwnedApps = this.apps.map((app) => app.adamId);
      const audience: IAudience = {
        // getting audience object set by adgroup screen
        ...LSS.adGroup.targetingDimensions,
        // age criteria
        ...(this.ageRange && {
          age: {
            included: [
              { minAge: this.ageRangeValue[0], maxAge: this.ageRangeValue[1] },
            ],
          },
        }),
        // gender criteria
        ...(this.selectedGender && {
          gender: {
            included: [this.selectedGender],
          },
        }),
        // App downloader criteria (customer type drop-down)
        ...(this.selectedCustomerType === CustomerTypes.NEW && {
          appDownloaders: {
            excluded: [adamId.toString()],
          },
        }),
        ...(this.selectedCustomerType === CustomerTypes.EXISITING && {
          appDownloaders: {
            included: [adamId.toString()],
          },
        }),
        ...(this.selectedCustomerType === CustomerTypes.OTHER_APPS && {
          appDownloaders: {
            included: [...allOwnedApps.map((adamId) => adamId.toString())],
          },
        }),
        ...(this.selectedLocation && {
          locality: { included: this.selectedLocation },
        }),
      };
      LSS.adGroup = {
        pricingModel: 'CPM',
        ...(LSS.adGroup.defaultBidAmount && {
          defaultBidAmount: LSS.adGroup.defaultBidAmount,
        }),
        ...(LSS.adGroup.cpaGoal && { cpaGoal: LSS.adGroup.cpaGoal }),
        ...(LSS.adGroup.startTime && { startTime: LSS.adGroup.startTime }),
        ...(LSS.adGroup.endTime && { endTime: LSS.adGroup.endTime }),
        ...(LSS.adGroup.status && { status: LSS.adGroup.status }),
        ...(LSS.adGroup.orgId && { orgId: LSS.adGroup.orgId }),
        ...(LSS.adGroup.automatedKeywordsOptIn && {
          automatedKeywordsOptIn: LSS.adGroup.automatedKeywordsOptIn,
        }),
        ...(LSS.adGroup.name && { name: LSS.adGroup.name }),
        targetingDimensions: audience,
      };

      this.createCampaign();
    },

    async runMutation(mutationOptions: IMutationOptions) {
      return await this.$apollo.mutate({
        mutation: mutationOptions.mutationQuery,
        variables: mutationOptions.variables,
      });
    },

    setCountries(data) {
      const Countries = data[0].countryOrRegionCodes;
      for (const countryCode of Countries) {
        for(const country of this.Countries){
          if(country.Code == countryCode){
            this.appCountries.push(country)
          }
        }
      }
    },
  },
  watch: {
    orgId(value) {
      // handling currency as per the org
      if (value)
        this.currency = this.getCampaignGroups.find(
          (group) => group.orgId === value
        ).currency;
    },
    searchLoc(query: string): void {
      query &&
        query !== this.selectedLocation &&
        this.selectedCountries.length === 1 &&
        query.length > 2 &&
        this.searchLocations(query, this.selectedCountries[0]);
    },
  },
  async created() {
    if (this.draftId) {
      this.$apollo.queries.campaignDraft.skip = false;
    }

    this.Countries = COUNTRIES;

    LSS.clearOther();
  },
});
